<template>
  <el-row class="panel-group" :gutter="10">
    <el-col :xs="24" :sm="24" :md="24" :lg="14">
      <el-col :xs="8" :sm="8" :md="8" :lg="8">
        <div class="card-panel" @click="handleSetLineChartData('purchases')">
          <div class="icon-moneyd">
            <div class="card-panel-icon-wrapper icon-money">
              <span class="icon iconfont icon-zichanxiangqing" style="font-size: xxx-large;"></span>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text" @click="goechali">库存金额</div>
              <count-to class="card-panel-num" :startVal="0" :endVal="9280" :duration="3200"></count-to>
            </div>
          </div>

        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" class="card-panel-col">
        <div class="card-panel" @click="handleSetLineChartData('messages')">
          <div class="icon-messaged">
            <div class="card-panel-icon-wrapper icon-message">
              <span class="icon iconfont icon-cangku_kucun_o" style="font-size: xxx-large;"></span>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">普耗库存</div>
              <count-to class="card-panel-num" :startVal="0" :endVal="81212" :duration="3000"></count-to>
            </div>
          </div>

        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" class="card-panel-col">
        <div class="card-panel" @click="handleSetLineChartData('messages')">
          <div class="icon-messaged">
            <div class="card-panel-icon-wrapper icon-message">
              <span class="icon iconfont icon-xiezaizujian" style="font-size: xxx-large;"></span>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">过期库存</div>
              <count-to class="card-panel-num" :startVal="0" :endVal="74321" :duration="3000"></count-to>
            </div>
          </div>

        </div>
      </el-col>
    </el-col>


    <el-col :xs="24" :sm="24" :md="24" :lg="10" class="card-panel-col">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" class="card-panel-col">
        <!-- <div class="top-right"> -->

        <div class="card-panel" @click="handleSetLineChartData('shoppings')">
          <div class="icon-shoppingCardd">
            <div class="card-panel-icon-wrapper icon-shoppingCard">
              <span class="icon iconfont icon-shouru" style="font-size: xxx-large;"></span>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">耗材金额</div>
              <count-to class="card-panel-num" :startVal="0" :endVal="13600" :duration="3600"></count-to>
            </div>
          </div>

        </div>
        <!-- </div> -->
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" class="card-panel-col">
        <div class='card-panel' @click="handleSetLineChartData('newVisitis')">
          <div class="icon-peopled">
            <div class="card-panel-icon-wrapper icon-people">
              <span class="icon iconfont icon-biaoqian" style="font-size: xxx-large;"></span>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">高值库存</div>
              <count-to class="card-panel-num" :startVal="0" :endVal="102400" :duration="2600"></count-to>
            </div>
          </div>
        </div>
      </el-col>
    </el-col>


  </el-row>
</template>
<script>
  import CountTo from 'vue-count-to'

  export default {
    components: {
      CountTo
    },
    methods: {
      handleSetLineChartData(type) {
        this.$emit('handleSetLineChartData', type)
      },
      goechali() {

        // window.open("http://10.168.50.39:12098/#/chart/home/22");
        window.open(" http://10.168.50.39:12098/#/chart/home/22");

      },
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .panel-group {

    .card-panel {
      margin-bottom: 20px;
    }

    .icon-peopled {
      height: 108px;
      display: flex;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      color: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      background-color: #fcb729;
      background-image: linear-gradient(135deg, #fcb729 0%, #f89d40 50%, #f68553 100%);
    }

    .icon-messaged {
      height: 108px;
      display: flex;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #FFF;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      background-color: #815bbf;
      background-image: linear-gradient(135deg, #815bbf 0%, #6b51ba 50%, #5647b5 100%);
    }

    .icon-moneyd {
      height: 108px;
      display: flex;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #FFF;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      background-color: #e74888;
      background-image: linear-gradient(135deg, #e74888 0%, #d24d95 50%, #bd54a1 100%);
    }

    .icon-shoppingCardd {
      height: 108px;
      display: flex;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #fff;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      background-color: #57caf2;
      background-image: linear-gradient(135deg, #57caf2 0%, #64b4ea 50%, #6ea1e4 100%);
    }


    .card-panel:hover {
      transition: all 0.5s;
      transform: scale(1.02);
    }

    .card-panel {
      height: 108px;
      // display: flex;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      width: 100%;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      border-radius: 10px;

      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }




        .icon-messaged {
          background-color: #815bbf;
          background-image: linear-gradient(135deg, #815bbf 0%, #6b51ba 50%, #5647b5 100%);

        }

        .icon-moneyd {
          background-color: #e74888;
          background-image: linear-gradient(135deg, #e74888 0%, #d24d95 50%, #bd54a1 100%);

        }

        .icon-shoppingCardd {
          background-color: #57caf2;
          background-image: linear-gradient(135deg, #57caf2 0%, #64b4ea 50%, #6ea1e4 100%);

        }
      }
    }
  }

  .card-panel-description {
    float: right;
    font-weight: bold;
    margin: 26px;
    margin-left: 0px;

    .card-panel-text {
      line-height: 18px;
      color: #fff;
      font-size: 16px;
      margin-bottom: 12px;
    }

    .card-panel-num {
      font-size: 20px;
    }
  }

  .icon-people {
    color: #fff;
  }

  .icon-message {
    color: #fff;
  }

  .icon-money {
    color: #fff;
  }

  .icon-shoppingCard {
    color: #fff
  }

  .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    transition: all 0.38s ease-out;
    border-radius: 6px;
  }

  .card-panel-icon {
    float: left;
    font-size: 48px;
  }

  .top-right {
    display: flex;
  }
</style>